import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const onboardingHubWizardEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-onboarding-hub-wizard" */ './OnboardingHubWizardEntryPointRoot.tsx'
		).then((module) => module.OnboardingHubWizardEntryPointRoot),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			id: context.match.params?.id || '',
		},
	}),
});
